import { render, staticRenderFns } from "./TabVerificaTratta.vue?vue&type=template&id=76b9ebc4&"
import script from "./TabVerificaTratta.vue?vue&type=script&lang=js&"
export * from "./TabVerificaTratta.vue?vue&type=script&lang=js&"
import style0 from "./TabVerificaTratta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabVerificaTratta.vue
// module id = 837
// module chunks = 0